module.exports = __webpack_public_path__ + "img/ctrl-aggregate-stub--i.222df07d.svg";